import { useCallback, useState } from 'react'
import { useIsMobile } from 'shared/hooks/useBreakpoint'

export default function useHeaderMobileSearch() {
	const isMobile = useIsMobile()
	const [searchExpanded, setSearchExpanded] = useState(false)

	const toggleSearch = useCallback(() => {
		setSearchExpanded(prev => !prev)
	}, [])

	const collapseSearch = useCallback(() => {
		setSearchExpanded(false)
	}, [])

	return {
		isMobile,
		searchExpanded,
		toggleSearch,
		collapseSearch,
	}
}
